export default "__VITE_ASSET__BS2E_x8g__"